import Const from '../Const'
class HigherTools{
  constructor(){
    this.instance = null
  }
  static createHigherToolsClass(){
    if(!this.instance){
      this.instance = new HigherTools()
    }
    return this.instance
  }
  debounce = (func,times)=>{
    let timer
    return (...rest)=>{
      if(!timer){
        timer = setTimeout(()=>{
          func(...rest)
          timer = null
        },times)
      }
      else{
        clearTimeout(timer)
        timer = setTimeout(()=>{
          func(...rest)
          timer = null
        },times)
      }
    }
  }
  throttle = (func,times)=>{
    let timer
    let ok = true
    return (...rest)=>{
      if(ok){
        ok = false
        timer = setTimeout(()=>{
          ok = true
        },times)
        func(...rest)
      }
    }
  }
}
export default HigherTools



// WEBPACK FOOTER //
// ./src/toolsClass/HigherTools.js